import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import ScreenSize from './ScreenSize';  /* current screen size for different scroll offsets */

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isOnHomepage = location.pathname === "/";

  // Screen size things

  const screenWidth = ScreenSize();   /* gets current screen width */

  const getOffset = (section) => {
    if (screenWidth <= 630) {
      switch (section) {
        case 'portfolios':
          return -25;
        case 'about':
          return -25;
        case 'contact':
          return 50;
        default:
          return -50;
      }
    } else if (screenWidth <= 768) {
      switch (section) {
        case 'portfolios':
          return -150;
        case 'about':
          return -125;
        case 'contact':
          return -40;
        default:
          return -150;
      }
    } else if (screenWidth <= 960) {
      switch (section) {
        case 'portfolios':
          return -150;
        case 'about':
          return -150;
        case 'contact':
          return -40;
        default:
          return -150;
      }
    } else {
      // large screens
      switch (section) {
        case 'portfolios':
          return -350;
        case 'about':
          return -125;
        case 'contact':
          return -40;
        default:
          return -150;
      }
    }
  };



  return (
    <ul className="navbar">
        <div className="navbar__container">
        <Link
          to="/"
          id="navbar__logo"
          onClick={(e) => {
            if (isOnHomepage) {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            setMenuOpen(false);
          }}
        >
          Minya
        </Link>

          <div
            className="navbar__toggle"
            id="mobile-menu"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        <ul className={`navbar__menu${menuOpen ? " active" : ""}`}>

        {/* Portfolios Section */}

      <li className="navbar__item">
        {isOnHomepage ? (
          <ScrollLink 
            to="portfolios" 
            smooth={true} 
            offset={getOffset('portfolios')}
            duration={500}
            className="navbar__links"
            onClick={() => setMenuOpen(false)}
          >
            portfolios
          </ScrollLink>
        ) : (
          <Link 
            to="/" 
            className="navbar__links" 
            state={{ scrollTo: 'portfolios', scrollOffset: getOffset('portfolios') }}
            onClick={() => setMenuOpen(false)}
          >
            portfolios
          </Link>
        )}
      </li>
      

      {/* About Section */}

      <li className="navbar__item">
        {isOnHomepage ? (
          <ScrollLink 
            to="about" 
            smooth={true} 
            offset={getOffset('about')}
            duration={500}
            className="navbar__links"
            onClick={() => setMenuOpen(false)}
          >
            about
          </ScrollLink>
        ) : (
          <Link 
            to="/" 
            className="navbar__links" 
            state={{ scrollTo: 'about', scrollOffset: getOffset('about') }}
            onClick={() => setMenuOpen(false)}
          >
            about
          </Link>
        )}
      </li>

      {/* Contact Section */}

      <li className="navbar__item">
        {isOnHomepage ? (
          <ScrollLink 
            to="contact" 
            smooth={true} 
            offset={getOffset('contact')}
            duration={500}
            className="navbar__links"
            onClick={() => setMenuOpen(false)}
          >
            contact
          </ScrollLink>
        ) : (
          <Link 
            to="/" 
            className="navbar__links" 
            state={{ scrollTo: 'contact', scrollOffset: getOffset('contact') }}
            onClick={() => setMenuOpen(false)}
          >
            contact
          </Link>
        )}
      </li>

      </ul>
      </div>
    </ul>
  );
};

export default Navbar;
